import { motion } from 'framer-motion';

export function AnimatedLines({ isActive, accentColor = 'red' }) {
    const color = colors[accentColor] || colors.red;

    return (
        <motion.div
            key={isActive ? 'show' : 'hide'}
            initial={{ opacity: 0 }}
            animate={isActive ? { opacity: 1 } : { opacity: 0 }}
            transition={{ duration: 0.6 }}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-20"
        >
            {/* Linha 1 */}
            <motion.div
                initial={{ scaleX: 0 }}
                animate={isActive ? { scaleX: 1 } : { scaleX: 0 }}
                transition={{
                    duration: 0.8,
                    delay: 1.95,
                    ease: [0.22, 1, 0.36, 1],
                }}
                className={`
          origin-left
          h-[2px] w-32
          mb-3
          ${color.strong}
        `}
            />

            {/* Linha 2 */}
            <motion.div
                initial={{ scaleX: 0 }}
                animate={isActive ? { scaleX: 1 } : { scaleX: 0 }}
                transition={{
                    duration: 0.6,
                    delay: 2.0,
                    ease: [0.22, 1, 0.36, 1],
                }}
                className={`
          origin-left
          h-px w-20
          ${color.soft}
        `}
            />
        </motion.div>
    );
}

const colors = {
    red: {
        strong: 'bg-green-600/70',
        soft: 'bg-green-600/30',
    },
    blue: {
        strong: 'bg-green-600/70',
        soft: 'bg-green-600/30',
    },
    green: {
        strong: 'bg-green-600/70',
        soft: 'bg-green-600/30',
    },
};
